<!-- <div
  class="element-container p-6 bg-white border border-slate-200 rounded-xl shadow-sm max-w-2xl font-sans"
> -->
<!-- <ng-content></ng-content> -->
<!-- </div> -->

@if (isVisible()) { @if (loadedComponent()) {
<ng-container *ngComponentOutlet="loadedComponent(); inputs: componentInputs()">
</ng-container>

<div class="element-plugin-layer">
  @for (plugin of elementPlugins(); track plugin.usageId) {
  <lib-plugin-host #pluginRef [pluginDef]="plugin"></lib-plugin-host>
  }
</div>

} @else {
<div class="loader">Loading Question...</div>
} }
